import { ConfigurationText } from '@reliance/types/models/ConfigurationText';
import React from 'react';
import Button from 'react-bootstrap/Button';
import { languageNameByCode } from './languageOptions';

export type ConfigurationTextListProps = {
  rows: ConfigurationText[];
  loading?: boolean;
  onEdit(row: ConfigurationText): void;
  getLanguageLabel?: (languageCode: string) => string;
};

const ConfigurationTextList: React.FC<ConfigurationTextListProps> = ({
  rows,
  loading = false,
  onEdit,
  getLanguageLabel = languageNameByCode,
}) => {
  if (loading && rows.length === 0) {
    return <p className="text-muted">Loading…</p>;
  }

  return (
    <table className="table table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th>Key</th>
          <th>Content</th>
          <th>Language</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td>{row.key}</td>
            <td>{row.content}</td>
            <td>{getLanguageLabel(row.language)}</td>
            <td>
              <Button variant="secondary" size="sm" onClick={() => onEdit(row)}>
                Edit
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ConfigurationTextList;
